import React from 'react';
import { yearsSuggestions } from '../../utils/data/date';
import { NewAutocompleteInput } from './NewAutocompleteInput';

export function NewYearInput(props) {
  return <NewAutocompleteInput {...props} suggestions={yearsSuggestions} />;
}
